import { Skeleton } from "@/components/ui/skeleton"

export function FinanceSettingsLayoutSkeleton() {
  return (
    <div className="space-y-6">
      {/* Tabs bar */}
      <div className="flex gap-1 rounded-lg bg-muted p-1 w-fit">
        <Skeleton className="h-8 w-24 rounded-md" />
        <Skeleton className="h-8 w-28 rounded-md" />
      </div>

      {/* Content area placeholder */}
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <Skeleton className="h-8 w-28" />
            <Skeleton className="h-5 w-48" />
          </div>
          <Skeleton className="h-9 w-28" />
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
              key={`skeleton-card-${i}`}
              className="rounded-xl border p-6 shadow-sm space-y-3"
            >
              <Skeleton className="h-5 w-1/2" />
              <Skeleton className="h-8 w-3/4" />
              <Skeleton className="h-4 w-1/3" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
